import type Phaser from 'phaser';

/**
 * Sprite "cuadrado de color" por entidad (TKT-015 + TKT-037).
 *
 * Spike 6.5 sin assets: el color se deriva determinísticamente del entityId
 * para players. Los enemies usan paleta visual diferenciada (rojo carmesí
 * con borde más grueso) — el cliente diferencia players de enemies para que
 * el jugador identifique sin ambigüedad qué es amistoso.
 */

const PLAYER_PALETTE = [0xff7a59, 0x5fa8ff, 0x8df58c, 0xf5c95f, 0xd07cff];
const ENEMY_COLOR = 0xa01829; // carmesí oscuro — paleta visual-direction.
const ENEMY_STROKE = 0xf4ecd8;
const HUESO_SOFT = 0xf4ecd8;

export type SpriteKind = 'player' | 'enemy';

export class EntitySprite {
  readonly entityId: string;
  readonly kind: SpriteKind;
  readonly rect: Phaser.GameObjects.Rectangle;

  constructor(
    scene: Phaser.Scene,
    entityId: string,
    screen: { x: number; y: number },
    kind: SpriteKind = 'player',
  ) {
    this.entityId = entityId;
    this.kind = kind;
    if (kind === 'enemy') {
      this.rect = scene.add.rectangle(screen.x, screen.y, 34, 34, ENEMY_COLOR, 1);
      this.rect.setStrokeStyle(3, ENEMY_STROKE, 0.9);
    } else {
      this.rect = scene.add.rectangle(screen.x, screen.y, 28, 28, pickPlayerColor(entityId), 1);
      this.rect.setStrokeStyle(2, HUESO_SOFT, 0.6);
    }
    this.rect.setDepth(kind === 'enemy' ? 2 : 1);
  }

  setScreenPosition(screen: { x: number; y: number }): void {
    this.rect.setPosition(screen.x, screen.y);
  }

  destroy(): void {
    this.rect.destroy();
  }
}

/** Alias para no romper imports existentes durante el refactor TKT-037. */
export const PlayerSprite = EntitySprite;

function pickPlayerColor(entityId: string): number {
  let hash = 0;
  for (let i = 0; i < entityId.length; i++) {
    hash = (hash * 31 + entityId.charCodeAt(i)) >>> 0;
  }
  return PLAYER_PALETTE[hash % PLAYER_PALETTE.length]!;
}
